<template>
    <b-badge pill :variant="'success'" v-if="is_novelty">
        Новинка
    </b-badge>
</template>

<script>
export default {
  props: {
    is_novelty: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style scoped>
    .badge {
        font-weight: normal;
    }
</style>
